/**
 * @generated SignedSource<<915ddbec75f4c2fe29a062dd9f64b090>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SplitRuleInputObject = {
  accountIdsA?: ReadonlyArray<string> | null | undefined;
  accountIdsB?: ReadonlyArray<string> | null | undefined;
  endDateA?: any | null | undefined;
  endDateB?: any | null | undefined;
  regexA?: string | null | undefined;
  regexB?: string | null | undefined;
  ruleId: string;
  selectedTxnIds?: ReadonlyArray<string> | null | undefined;
  startDateA?: any | null | undefined;
  startDateB?: any | null | undefined;
};
export type similarityPage_SplitRuleMutation$variables = {
  input: SplitRuleInputObject;
};
export type similarityPage_SplitRuleMutation$data = {
  readonly splitRule: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly rules: ReadonlyArray<{
      readonly id: string;
    }> | null | undefined;
  } | null | undefined;
};
export type similarityPage_SplitRuleMutation = {
  response: similarityPage_SplitRuleMutation$data;
  variables: similarityPage_SplitRuleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Rule",
  "kind": "LinkedField",
  "name": "rules",
  "plural": true,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "similarityPage_SplitRuleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SplitRuleMutationPayload",
        "kind": "LinkedField",
        "name": "splitRule",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "similarityPage_SplitRuleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SplitRuleMutationPayload",
        "kind": "LinkedField",
        "name": "splitRule",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "39ba809f1efbb231b30d678d496e785f",
    "id": null,
    "metadata": {},
    "name": "similarityPage_SplitRuleMutation",
    "operationKind": "mutation",
    "text": "mutation similarityPage_SplitRuleMutation(\n  $input: SplitRuleInputObject!\n) {\n  splitRule(input: $input) {\n    rules {\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d736788a572bda7acd22454a2d92a9fa";

export default node;
